import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import replace from 'lodash/replace';
import includes from 'lodash/includes';
import { Interweave } from 'interweave';
import NoSsr from '@mui/material/NoSsr';
import ContextProvider from '../../../context';
import CustomModal from '../../../components/Modals/Modal';
import SkillEvaluationForm from './SkillEvaluationForm';
import s from './SkillEvaluationModal.scss';
import history from '../../../history';
var messages = defineMessages({
  saveLabel: {
    id: "General.saveLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Save"
    }]
  }
});
var SkillEvaluationModal = function SkillEvaluationModal(_ref) {
  var isOpen = _ref.isOpen,
    onSave = _ref.onSave,
    courseId = _ref.courseId;
  var _useContext = useContext(ContextProvider),
    fetch = _useContext.fetch;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    skillLevel = _useState2[0],
    setSkillLevel = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    snackbarError = _useState6[0],
    setSnackbarError = _useState6[1];
  var onSkillLevelSave = function onSkillLevelSave() {
    setIsSubmitting(true);
    return fetch('/api/user_skills', {
      method: 'POST',
      body: JSON.stringify({
        skillLevel: skillLevel,
        courseId: courseId
      })
    }).then(function (res) {
      var query = history.location.search;
      if (includes(query, 'showEvaluationModal')) {
        history.replace({
          search: replace(query, 'showEvaluationModal', '')
        });
      }
      if (!res.ok) {
        return res.json().then(function (err) {
          if (err.message && res.status === 412) {
            return setSnackbarError(err.message);
          }
          throw new Error(res.statusText);
        });
      }
      setIsSubmitting(false);
      return onSave();
    })["catch"](function (err) {
      setIsSubmitting(false);
      console.error(err);
    });
  };
  var onCloseSnackbar = function onCloseSnackbar() {
    setSnackbarError('');
    return onSave();
  };
  return /*#__PURE__*/_jsx(CustomModal, {
    isOpen: isOpen,
    classes: {
      paper: s.paper
    },
    "aria-describedby": "course-skill-evaluation-modal",
    "data-test": "course-skill-evaluation-modal"
  }, void 0, /*#__PURE__*/_jsx(SkillEvaluationForm, {
    setSkillLevel: setSkillLevel,
    skillLevel: skillLevel
  }), /*#__PURE__*/_jsx("div", {
    className: s.actions
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "Q6VHQxv6e1hrJuQZjffQU",
    fullWidth: true,
    color: "primary",
    size: "medium",
    variant: "outlined",
    onClick: onSkillLevelSave,
    "data-test": "skill-evaluation-modal-submit-btn",
    disabled: isSubmitting
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.saveLabel))), /*#__PURE__*/_jsx(Snackbar, {
    open: !!snackbarError,
    autoHideDuration: 2000,
    onClose: onCloseSnackbar,
    message: /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
      content: snackbarError
    }))
  }));
};
export default injectIntl(withStyles(s)(SkillEvaluationModal));